import { render, staticRenderFns } from "./LotDetailsFormIndividual.vue?vue&type=template&id=288b52d0"
import script from "./LotDetailsFormIndividual.vue?vue&type=script&lang=js"
export * from "./LotDetailsFormIndividual.vue?vue&type=script&lang=js"
import style0 from "./LotDetailsFormIndividual.vue?vue&type=style&index=0&id=288b52d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports